<template>
  <Toast
    position="top-left"
    group="headlessRecipePriceUpdate"
    severity="info"
  >
    <template #container="{ message }">
      <div class="p-4 rounded-lg toastProgressContainer text-black dark:text-black shadow-md w-full">
        <div class="flex items-center gap-3 mb-2">
          <i class="pi pi-cloud-upload text-xl" />
          <span class="font-semibold">{{ message.summary }}</span>
        </div>

        <ProgressBar
          :value="progressToUpdatePrice"
          :showValue="false"
          class="h-1"
        />

        <p class="text-xs mt-2 font-medium">
          {{ recipesToUpdatePriceProcessedCount }} / {{ recipesToUpdatePriceToProcessTotalCount }} recettes mises à jour
        </p>
      </div>
    </template>
  </Toast>

  <Toast
    position="top-left"
    group="headlessRecipeLoadDetail"
    severity="info"
  >
    <template #container="{ message }">
      <div class="p-4 rounded-lg toastProgressContainer text-black dark:text-black shadow-md w-full">
        <div class="flex items-center gap-3 mb-2">
          <i class="pi pi-cloud-upload text-xl" />
          <span class="font-semibold">{{ message.summary }}</span>
        </div>

        <ProgressBar
          :value="progressToLoadDetail"
          :showValue="false"
          class="h-1"
        />

        <p class="text-xs mt-2 font-medium">
          {{ recipesToLoadDetailProcessedCount }} / {{ recipesToLoadDetailToProcessTotalCount }} recettes chargées
        </p>
        <div>
          <Button
            label="Arreter"
            ico="pi pi-stop"
            @click="stopLoadDetail"
            />

        </div>
      </div>
    </template>
  </Toast>
  
</template>

<script>
import { computed, watch } from 'vue'

import Toast from 'primevue/toast';
import { ProgressBar, Button } from 'primevue';


import { storeToRefs } from 'pinia';

import { useAdminDataStore } from '../../stores/admin';
import { useToast } from "primevue/usetoast";
import get from '../../services/get';

export default {
  name: "AdminToastPendingOperation",
  setup() {
    const adminDataStore = useAdminDataStore();
    
    
    const { 
      editedRecipe,

      recipesToUpdatePrice,
      recipesToUpdatePriceProcessedCount,
      recipesToUpdatePriceToProcessTotalCount,

      recipesToLoadDetail,      
      recipesToLoadDetailProcessedCount,
      recipesToLoadDetailToProcessTotalCount,

    } = storeToRefs(adminDataStore);
/*
    const recipesToUpdatePriceCount = computed(() => {
      return recipesToUpdatePrice.value.length;
    });
*/
    const toast = useToast();
    
    const clearToastRecipePriceUpdate = () => {
        toast.removeGroup('headlessRecipePriceUpdate');
    };
    const clearToastRecipeLoadDetail = () => {
        toast.removeGroup('headlessRecipeLoadDetail');
    };

    const progressRecipePriceUpdateDisplayed = computed(() => {
      return recipesToUpdatePrice.value.length > 0;
    });

    const progressRecipeToLoadDetailDisplayed = computed(() => {
      return recipesToLoadDetail.value.length > 0;
    });

    const progressToUpdatePrice = computed(() => {      
      if(recipesToUpdatePriceToProcessTotalCount.value == 0) {
        return 0;
      }
      return 100 * recipesToUpdatePriceProcessedCount.value / recipesToUpdatePriceToProcessTotalCount.value;
    });

    const progressToLoadDetail = computed(() => {      
      if(recipesToLoadDetailToProcessTotalCount.value == 0) {
        return 0;
      }
      return 100 * recipesToLoadDetailProcessedCount.value / recipesToLoadDetailToProcessTotalCount.value;
    });
    
    watch(progressRecipePriceUpdateDisplayed, () => {
      if(progressRecipePriceUpdateDisplayed.value) {
        toast.add({ 
          severity: 'custom', 
          summary: 'Mise à jour des prix recette', 
          group: 'headlessRecipePriceUpdate', 
          //styleClass: 'backdrop-blur-lg rounded-2xl' 
          styleClass: 'shadow-lg rounded-xl px-4 py-3'

        });
      }else{
        clearToastRecipePriceUpdate();
        adminDataStore.resetToUpdatePrices();
      }
    });
    watch(progressRecipeToLoadDetailDisplayed, () => {
      if(progressRecipeToLoadDetailDisplayed.value) {
        toast.add({ 
          severity: 'custom', 
          summary: 'Chargement du détail des recettes', 
          group: 'headlessRecipeLoadDetail', 
          styleClass: 'shadow-lg rounded-xl px-4 py-3'

        });
      }else{
        clearToastRecipeLoadDetail();
        adminDataStore.resetRecipeToLoadDetail();
      }
    });

    
    let isAlreadyUpdatingPrice = false;
    watch(recipesToUpdatePrice, async () => {
      if(isAlreadyUpdatingPrice) {
        return;
      }
      isAlreadyUpdatingPrice = true;
      if(recipesToUpdatePrice.value.length >= 1) {
        const foodRecipeId = recipesToUpdatePrice.value[0];

        let isEditedRecipe = false;
        if(editedRecipe.value && editedRecipe.value.id == foodRecipeId) {
          isEditedRecipe = true;
        }
        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(true);
        }
        await get.refreshFoodRecipeRecipePrice(foodRecipeId);

        adminDataStore.incrementRecipesToUpdatePriceProcessedCount();
        adminDataStore.setRecipesToUpdatePriceProcessed(foodRecipeId);

        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(false);
        }
      }
      isAlreadyUpdatingPrice = false;
    });

    
    let isAlreadyLoadingDetail = false;
    watch(recipesToLoadDetail, async () => {
      if(isAlreadyLoadingDetail) {
        return;
      }
      isAlreadyLoadingDetail = true;
      if(recipesToLoadDetail.value.length >= 1) {
        const foodRecipeId = recipesToLoadDetail.value[0];

        let isEditedRecipe = false;
        if(editedRecipe.value && editedRecipe.value.id == foodRecipeId) {
          isEditedRecipe = true;
        }
        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(true);
        }
        
        const forceRefresh = true;
        const doAjaxCall = true;
        await get.getFoodRecipe(foodRecipeId, forceRefresh, doAjaxCall);

        adminDataStore.incrementRecipesToLoadDetailProcessedCount();

        adminDataStore.setRecipesToLoadDetailProcessed(foodRecipeId);

        if(isEditedRecipe) {
          adminDataStore.setRecipeShouldNotPropagateRefreshBeauseRefreshIngredientPrice(false);
        }
      }
      isAlreadyLoadingDetail = false;
    });

    const stopLoadDetail = () => {
      clearToastRecipeLoadDetail();
      adminDataStore.resetRecipeToLoadDetail();
    };
           

    return {
      progressRecipePriceUpdateDisplayed,
      recipesToUpdatePriceProcessedCount,
      recipesToUpdatePriceToProcessTotalCount,
      progressToUpdatePrice,

      
      progressRecipeToLoadDetailDisplayed,
      recipesToLoadDetailProcessedCount,
      recipesToLoadDetailToProcessTotalCount,
      progressToLoadDetail,
      stopLoadDetail,
    };
  },
  components: {
    Button,
    Toast,
    ProgressBar,
}
};
</script>

<style lang="scss">
  @import '../../css/backend.scss';

  .field-checkbox {
    & > div, & > label {
      display: inline-block;
    }
  }
  .sendMultiMail {
    input.p-inputtext {
      width: 90%;
    }
    textarea.p-inputtextarea {
      width: 90%;
    }
  }
  .sm-admin {
    .pi-home {
      cursor: pointer;
      &.nothome {
        opacity: 0.2;
        color: red;
      }
    }
  }

</style>